import { render, staticRenderFns } from "./TrainingItemSectionForm.vue?vue&type=template&id=11466b7c&"
import script from "./TrainingItemSectionForm.vue?vue&type=script&lang=js&"
export * from "./TrainingItemSectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports